export enum DefaultOffOverride {
    DEFAULT = "Default",
    Override = "Override",
    Off = "Off",
}
